/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FC } from 'react'
import serviceApi from "../../modules/tp/services/_requests";
import { Service, emptyService } from "../../modules/tp/services/_models";
import { Column } from "app/partials/entity/Table";
import ServiceFormBuilder from "app/modules/tp/services/builders/ServiceFormBuilder";
import PageWrapper from "app/partials/entity/PageWrapper";
import moment from 'moment';
import { getStatusColor } from "app/modules/tp/services/utility";

const dateFormat = 'DD/MM/YYYY';

const translateStatusName = (status: string) => {
    switch (status) {
        case '_':
            return 'Nessun filtro';
        case 'TO_START':
            return 'Da effettuare';
        case 'IN_PROGRESS':
            return 'In Corso';
        case 'FINISHED':
            return 'Terminato';
        case 'CANCELED':
            return 'Cancellato';
        default:
            return '';
    }
}

const columns: Array<Column<Service>> = [
    {
        key: "status",
        label: "Stato",
        width: '150px',
        filterable: true,
        filterType: 'select',
        cellStyle: (service: Service, column: Column<Service>) => ( { backgroundColor: getStatusColor(service), padding: '5px', borderRadius: '5px' }),
        filterOptions: [
            { label: 'Nessun filtro', value: '_' },
            { label: 'Da effettuare', value: 'TO_START' },
            { label: 'In Corso', value: 'IN_PROGRESS' },
            { label: 'Terminato', value: 'FINISHED' },
            { label: 'Cancellato', value: 'CANCELED' }
        ],
        sortable: true,
        render: (service: Service) => (<>{translateStatusName(service?.status)}</>)
    },
    {
        key: "title",
        label: "Titolo Servizio",
        filterable: true,
        sortable: true,
    },
    {
        key: "client",
        label: "Cliente",
        filterOn: 'business_name',
        filterable: true,
        sortable: true,
        render: (service: Service) => (<>{service.client?.displayed_name ?? service?.client?.business_name}</>),
    },
    {
        key: "start_date",
        label: "Data inizio",
        filterType: 'date',
        filterable: true,
        sortable: true,
        render: (service: Service) => {
            return (<>{service.start_date ? moment(service.start_date, dateFormat).format(dateFormat) : ''}</>)
        }
    },
    {
        key: "end_date",
        label: "Data fine",
        filterType: 'date',
        filterable: true,
        sortable: true,
        render: (service: Service) => (<>{service.end_date ? moment(service.end_date, dateFormat).format(dateFormat) : ''}</>),
    },
    {
        key: "rides",
        label: "N° Corse",
        width: '80px',
        filterable: true,
        sortable: true,
        render: (service: Service) => (<>{service.rides?.length || 0}</>),
    },
    {
        key: "quotation",
        label: "N° Prev.",
        filterable: true,
        sortable: true,
    },
    {
        key: "quotation_date",
        label: "Data Prev.",
        filterType: 'date',
        filterable: true,
        sortable: true,
        render: (service: Service) => (<>{service.quotation_date ? moment(service.quotation_date, dateFormat).format(dateFormat) : ''}</>),
    },
    {
        key: "selling_price",
        label: "Prezzo di Vendita (IVA esclusa)",
        filterable: true,
        sortable: true,
        render: (service: Service) => (<>{'€ ' + (service.selling_price ? service.selling_price : 0)}</>),
    },
    {
        key: "purchase_price",
        label: "Prezzo di Acquisto (IVA esclusa)",
        filterable: true,
        sortable: true,
        render: (service: Service) => (<>{'€ ' + (service.purchase_price ? service.purchase_price : 0)}</>),
    },
];

const entityIcon = "fa-solid fa-clipboard-list";

const ServicesPage: FC = () => {
    return (
        <PageWrapper
            columns={columns}
            emptyEntity={emptyService}
            entityIcon={entityIcon}
            entityApi={serviceApi}
            viewDefaultFilters={{
                "status[eq]": "TO_START",
            }}
            viewDefaultSorters={{
                "start_date": "ASC",
            }}
            labels={{
                icon: entityIcon,
                singleEntityName: "Servizio",
                pluralEntityName: "Servizi",
            }}
            form={ServiceFormBuilder()}
        />
    );
};


export { ServicesPage }
